import * as Yup from "yup";

export const postValidationSchema = Yup.object({
  title: Yup.string()
    .min(10, "Titulli duhet të ketë të paktën 10 karaktere")
    .max(200, "Titulli duhet të ketë më pak se 200 karaktere")
    .required("Titulli është i detyrueshëm"),

  excerpt: Yup.string()
    .max(300, "Përmbledhja duhet të ketë më pak se 300 karaktere")
    .required("Përmbledhja është e detyrueshme"),

  categories: Yup.array()
    .min(1, "Të paktën një kategori është e detyrueshme")
    .required("Kategoritë janë të detyrueshme"),

  slug: Yup.string()
    .matches(/^[a-z0-9]+(?:-[a-z0-9]+)*$/, "Formati i slug-ut është i pavlefshëm")
    .required("Slug-u është i detyrueshëm"),

  metaDescription: Yup.string().max(
    160,
    "Përshkrimi meta duhet të ketë më pak se 160 karaktere"
  ),
});
